import React from 'react';
import classnames from 'classnames';
import bemBlock from '@gik/core/utils/bemBlock';
import Slider, { Settings } from 'react-slick';
import Box, { IBoxProps } from '../../Box';

export interface IBoxCarouselProps extends Settings, Omit<IBoxProps, 'draggable'> {
  children?: React.ReactNode;
  fadeSides?: boolean;
  contained?: boolean;
}

export default function BoxCarousel({
  children,
  fadeSides,
  contained,
  className,
  variant,
  ...otherProps
}: IBoxCarouselProps): React.ReactElement {
  const bem = bemBlock('box-carousel');
  const blockClasses = classnames([
    bem(),
    { [`${bem()}--fade-sides`]: fadeSides },
    { [`${bem()}--contained`]: contained },
    className || '',
  ]);

  const settings: Settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 8000,
    ...otherProps,
  };

  return (
    <Box className={blockClasses} variant={variant}>
      <main>
        <Slider {...settings}>{children}</Slider>
      </main>
      <div className={bem('mask')}></div>
    </Box>
  );
}
